<template>
    <div >
	<DeliverySettings :baseURL='baseURL' :qiybh="qiybh" :userName="userName"></DeliverySettings>
    </div>
</template>
<script>
import config from '../../../../configHttp.js'
  export default {
    components: {
     
    },
      created() {
      		  if(localStorage.getItem('useropj')){
      			  var useropj=JSON.parse(localStorage.getItem('useropj'))
      			  this.baseURL=config.baseExpressURL
      			 this.qiybh=useropj.currCompany.code
      			  this.userName=useropj.userName
      		  }
      		
      },
  
    data(){
      return{
        baseURL:"",
        qiybh:"",
		userName:""
      }
    }
  };
</script>
<style  scoped="scoped">

</style>